import { types } from './referralsTypes';

export const saveListReferrer = (payload) => ({ type: types.GET_LIST_REFERRER, payload });
export const saveListReferral = (payload) => ({ type: types.LIST_REFERRAL, payload });
export const saveAllReferralInfo = (payload) => ({ type: types.ALL_REFERRAL_INFO, payload });
export const saveStatistics = (payload) => ({ type: types.GET_STATISTICS, payload });
export const savePercent = (payload) => ({ type: types.GET_PERCENT, payload });